import React from 'react';
import { Link } from 'react-router-dom';
import './block1.css';

function Block1() {
    return (
        <div className="block block_1">
            <div className="container">
                <h1>酒吧VIP改版囉！</h1><br />
                <p>
                    感謝玩家對遊戲酒吧長久以來的支持，遊戲酒吧從2014年起推出VIP會員專屬回饋，期待讓酒吧VIP享有最好的服務。這三年來我們收到許多來自玩家的鼓勵，也認真聆聽玩家給我們的建議，這次改版納入玩家們最常提到建議，讓回饋更及時、也更符合玩家期待~~~
                </p>
                <p>2017/09/01開始，酒吧推出全新VIP方案。新制VIP的兩大特點:</p>
                <ul style={{ paddingLeft: '0px' }}>
                    <li>累積儲值金額達門檻即可享有<span>指定管道儲值回饋</span></li>
                    <li>採<span>點數加碼回饋</span>方式，儲值越多的玩家得到越多點數加碼! </li>
                </ul>
                <p>
                    即日起，可於遊戲酒吧<Link className="link_vip" to="/vip" style={{ color: '#00a0e9' }}>VIP專區</Link>查詢累積儲值金額及VIP資格~
                </p>
            </div>
        </div>
    );
}

export default Block1;


// WEBPACK FOOTER //
// ./src/containers/home/block1.jsx